"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var react_2 = require("@nextui-org/react");
var react_redux_1 = require("react-redux");
var update_product_1 = require("../../../../../../api/calls/product/update_product");
var tabel_cell_1 = require("../../../../../../components/tabel_cell");
var sanitiseObject_1 = require("../../../../../../helpers/sanitiseObject");
var useSearchDebounce_1 = require("../../../../../../hooks/useSearchDebounce");
var get_client_condiments_thunk_1 = require("../../../../../../reducers/slices/condiments/thunks/get_client_condiments_thunk");
var main_1 = require("../../../../../../reducers/slices/main");
var columns = [
    { name: "Type", uid: "type" },
    { name: "Min Quantity", uid: "minimum_quantity" },
    { name: "Max Quantity", uid: "maximum_quantity" },
    { name: "Required", uid: "required" },
    { name: "Multiple", uid: "multiple" },
];
var productColumns = [
    { name: "Name", uid: "name" },
    { name: "Price", uid: "price" },
    { name: "Required", uid: "required" },
    { name: "Default", uid: "default" },
];
var INITIAL_VISIBLE_COLUMNS = ["type", "minimum_quantity", "maximum_quantity", "required", "multiple"];
var PimCondimentGroupsComponent = function (_a) {
    var _b;
    var values = _a.values, setValues = _a.setValues;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _c = (0, useSearchDebounce_1.useSearchDebounce)(), searchCondiments = _c[0], setSearchCondiments = _c[1];
    var _d = (0, react_1.useState)(""), selectedCondiment = _d[0], setSelectedCondiment = _d[1];
    var _e = (0, react_1.useState)(false), showSaveChangesLabel = _e[0], setShowSaveChangesLabel = _e[1];
    var _f = (0, react_1.useState)(1), currentPage = _f[0], setCurrentPage = _f[1];
    var _g = (0, react_1.useState)(10), rowsPerPage = _g[0], setRowsPerPage = _g[1];
    var client_token = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).client_token;
    var _h = (0, react_redux_1.useSelector)(function (state) { return state.condimentState; }), condiments = _h.condiments, pagination = _h.pagination, loading = _h.loading;
    (0, react_1.useEffect)(function () {
        if (client_token) {
            getCondiments(__assign({}, pagination));
        }
    }, [client_token]);
    (0, react_1.useEffect)(function () {
        onSearch(searchCondiments);
    }, [searchCondiments]);
    var onSearch = function (search_string) {
        getCondiments(__assign(__assign({}, pagination), { search_string: search_string !== null && search_string !== void 0 ? search_string : "" }));
    };
    var getCondiments = function (query) { return dispatch((0, get_client_condiments_thunk_1.get_condiments_thunk)(query)); };
    var headerColumns = (0, react_1.useMemo)(function () {
        var visibleColumns = new Set(INITIAL_VISIBLE_COLUMNS);
        return columns.filter(function (column) { return Array.from(visibleColumns).includes(column.uid); });
    }, []);
    var handleDropdownChange = function (value) {
        setSelectedCondiment(value);
        var group = condiments === null || condiments === void 0 ? void 0 : condiments.find(function (item) { return item._id === value; });
        var groupExists = values.condiments.some(function (item) { return item._id === (group === null || group === void 0 ? void 0 : group._id); });
        if (!groupExists) {
            setValues(__assign(__assign({}, values), { condiments: __spreadArray(__spreadArray([], values.condiments, true), [group], false) }));
            setShowSaveChangesLabel(true);
        }
        else {
            dispatch((0, main_1.setMessageModal)({
                title: "Condiment Group already exists!",
                messages: ["Please select a different condiment group."],
            }));
        }
    };
    var handleQuantityChange = function (e, groupId, field) {
        var updatedCondiments = values.condiments.map(function (group) {
            var _a;
            if (group._id === groupId) {
                return __assign(__assign({}, group), (_a = {}, _a[field] = e.target.value, _a));
            }
            return group;
        });
        setValues(__assign(__assign({}, values), { condiments: updatedCondiments }));
        setShowSaveChangesLabel(true);
    };
    var handleRemoveGroup = function (groupId) {
        var filteredGroups = values.condiments.filter(function (group) { return group._id !== groupId; });
        setValues(__assign(__assign({}, values), { condiments: filteredGroups }));
        setShowSaveChangesLabel(true);
    };
    var renderGroupCellViews = function (cellValue, columnRecord) { return [
        {
            key: "minimum_quantity",
            content: ((0, jsx_runtime_1.jsx)(react_2.Input, { type: "number", size: "sm", value: columnRecord.minimum_quantity, className: "w-24", onChange: function (e) { return handleQuantityChange(e, columnRecord._id, "minimum_quantity"); } })),
        },
        {
            key: "maximum_quantity",
            content: ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex items-center gap-2" }, { children: [(0, jsx_runtime_1.jsx)(react_2.Input, { type: "number", size: "sm", value: columnRecord.maximum_quantity, className: "w-24", onChange: function (e) { return handleQuantityChange(e, columnRecord._id, "maximum_quantity"); } }), (0, jsx_runtime_1.jsx)(react_2.Button, __assign({ isIconOnly: true, color: "danger", size: "sm", onClick: function () { return handleRemoveGroup(columnRecord._id); } }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faTrash }) }))] }))),
        },
        {
            key: "required",
            content: ((0, jsx_runtime_1.jsx)(react_2.Checkbox, { isSelected: cellValue, onChange: function (checked) {
                    var updatedCondiments = values.condiments.map(function (group) {
                        if (group._id === columnRecord._id) {
                            return __assign(__assign({}, group), { required: checked });
                        }
                        return group;
                    });
                    setValues(__assign(__assign({}, values), { condiments: updatedCondiments }));
                    setShowSaveChangesLabel(true);
                } })),
        },
        {
            key: "multiple",
            content: ((0, jsx_runtime_1.jsx)(react_2.Checkbox, { isSelected: cellValue, onChange: function (checked) {
                    var updatedCondiments = values.condiments.map(function (group) {
                        if (group._id === columnRecord._id) {
                            return __assign(__assign({}, group), { multiple: checked });
                        }
                        return group;
                    });
                    setValues(__assign(__assign({}, values), { condiments: updatedCondiments }));
                    setShowSaveChangesLabel(true);
                } })),
        },
    ]; };
    var renderProductCellViews = function (cellValue, columnRecord, groupId) { return [
        {
            key: "required",
            content: ((0, jsx_runtime_1.jsx)(react_2.Checkbox, { isSelected: cellValue, onChange: function (checked) {
                    var updatedCondiments = values.condiments.map(function (group) {
                        if (group._id === groupId) {
                            var updatedProducts = group.product_list.map(function (product) {
                                if (product._id === columnRecord._id) {
                                    return __assign(__assign({}, product), { required: checked });
                                }
                                return product;
                            });
                            return __assign(__assign({}, group), { product_list: updatedProducts });
                        }
                        return group;
                    });
                    setValues(__assign(__assign({}, values), { condiments: updatedCondiments }));
                    setShowSaveChangesLabel(true);
                } })),
        },
        {
            key: "default",
            content: ((0, jsx_runtime_1.jsx)(react_2.Checkbox, { isSelected: cellValue, onChange: function (checked) {
                    var updatedCondiments = values.condiments.map(function (group) {
                        if (group._id === groupId) {
                            var updatedProducts = group.product_list.map(function (product) {
                                if (product._id === columnRecord._id) {
                                    return __assign(__assign({}, product), { default: checked });
                                }
                                return product;
                            });
                            return __assign(__assign({}, group), { product_list: updatedProducts });
                        }
                        return group;
                    });
                    setValues(__assign(__assign({}, values), { condiments: updatedCondiments }));
                    setShowSaveChangesLabel(true);
                } })),
        },
    ]; };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var params, transformedCondiments, response;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    params = (0, sanitiseObject_1.sanitiseObject)(__assign({}, values));
                    transformedCondiments = (_a = params === null || params === void 0 ? void 0 : params.condiments) === null || _a === void 0 ? void 0 : _a.map(function (condiment) {
                        var _a;
                        return ({
                            condiment_id: condiment._id,
                            default_product_id: ((_a = condiment.product_list.find(function (p) { return p.default; })) === null || _a === void 0 ? void 0 : _a._id) || null,
                            required_products: condiment.product_list.filter(function (p) { return p.required; }).map(function (p) { return p._id; }),
                        });
                    });
                    params.condiments = transformedCondiments;
                    return [4 /*yield*/, (0, update_product_1.update_product)(params)];
                case 1:
                    response = _b.sent();
                    if (response.success) {
                        setShowSaveChangesLabel(false);
                        dispatch((0, main_1.setMessageModal)({
                            title: "Success...",
                            messages: [response.message],
                        }));
                    }
                    else {
                        dispatch((0, main_1.setMessageModal)({
                            title: "Error updating product details",
                            messages: [response.message],
                        }));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)(react_2.Card, __assign({ className: "w-full" }, { children: [(0, jsx_runtime_1.jsxs)(react_2.CardHeader, __assign({ className: "flex justify-between items-center px-6 py-4" }, { children: [(0, jsx_runtime_1.jsx)("h3", __assign({ className: "text-lg font-semibold" }, { children: "Condiment Groups" })), (0, jsx_runtime_1.jsx)(react_2.Button, __assign({ startContent: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faCloud }), color: "primary", isDisabled: !showSaveChangesLabel, onClick: handleSave }, { children: "Save Changes" }))] })), (0, jsx_runtime_1.jsx)(react_2.Divider, {}), (0, jsx_runtime_1.jsxs)(react_2.CardBody, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "px-4" }, { children: (0, jsx_runtime_1.jsx)(react_2.Select, __assign({ label: "Select Condiment Group", className: "w-80 mb-2", onChange: function (e) { return handleDropdownChange(e.target.value); } }, { children: condiments === null || condiments === void 0 ? void 0 : condiments.map(function (group) { return ((0, jsx_runtime_1.jsx)(react_2.SelectItem, __assign({ value: group._id }, { children: group.type }), group._id)); }) })) })), (0, jsx_runtime_1.jsxs)(react_2.Table, __assign({ "aria-label": "Condiment groups table", isHeaderSticky: true, className: "p-0 gap-0", shadow: "none", bottomContentPlacement: "outside", classNames: {
                            td: "before:bg-transparent",
                        }, selectionMode: "none", topContentPlacement: "inside", onCellAction: function (e) { } }, { children: [(0, jsx_runtime_1.jsx)(react_2.TableHeader, __assign({ columns: headerColumns }, { children: function (column) { return ((0, jsx_runtime_1.jsx)(react_2.TableColumn, __assign({ className: (0, react_2.cn)([column.uid === "actions" ? "flex items-center justify-end px-[20px]" : ""]) }, { children: column.name }), column.uid)); } })), (0, jsx_runtime_1.jsx)(react_2.TableBody, __assign({ emptyContent: "This table is empty.", items: values === null || values === void 0 ? void 0 : values.condiments, loadingContent: (0, jsx_runtime_1.jsx)(react_2.Spinner, { label: "Loading..." }) }, { children: function (group) { return ((0, jsx_runtime_1.jsx)(react_2.TableRow, { children: function (columnKey) { return ((0, jsx_runtime_1.jsx)(react_2.TableCell, { children: (0, jsx_runtime_1.jsx)(tabel_cell_1.TableCellComponent, { columnRecord: group, columnKey: columnKey, renderCellViews: renderGroupCellViews }) })); } }, group._id)); } }))] })), (_b = values === null || values === void 0 ? void 0 : values.condiments) === null || _b === void 0 ? void 0 : _b.map(function (group) { return ((0, jsx_runtime_1.jsx)(react_2.Card, __assign({ className: "mt-4" }, { children: (0, jsx_runtime_1.jsxs)(react_2.CardBody, { children: [(0, jsx_runtime_1.jsxs)("h4", __assign({ className: "text-base font-medium mb-2" }, { children: ["Products for ", group.type] })), (0, jsx_runtime_1.jsxs)(react_2.Table, __assign({ "aria-label": "Products table", className: "mt-2", selectionMode: "none" }, { children: [(0, jsx_runtime_1.jsx)(react_2.TableHeader, { children: productColumns.map(function (column) { return ((0, jsx_runtime_1.jsx)(react_2.TableColumn, { children: column.name }, column.uid)); }) }), (0, jsx_runtime_1.jsx)(react_2.TableBody, __assign({ items: group.product_list }, { children: function (product) { return ((0, jsx_runtime_1.jsx)(react_2.TableRow, { children: function (columnKey) { return ((0, jsx_runtime_1.jsx)(react_2.TableCell, { children: (0, jsx_runtime_1.jsx)(tabel_cell_1.TableCellComponent, { columnRecord: product, columnKey: columnKey, renderCellViews: function (cellValue, columnRecord) { return renderProductCellViews(cellValue, columnRecord, group._id); } }) })); } }, product._id)); } }))] }))] }) }), group._id)); })] })] })));
};
exports.default = PimCondimentGroupsComponent;
